export type TextWidthMeasurer = (text: string, font: string) => number;

let textMeasurementContext: CanvasRenderingContext2D | null | undefined;

function getTextMeasurementContext() {
  if (textMeasurementContext !== undefined) return textMeasurementContext;
  if (typeof document === 'undefined') return null;

  const canvas = document.createElement('canvas');
  textMeasurementContext = canvas.getContext('2d');
  return textMeasurementContext;
}

// Rough per-character estimate for environments without canvas support (e.g. jsdom).
function estimateTextWidth(text: string) {
  return Array.from(text).reduce((width, character) => {
    if (/\s/.test(character)) return width + 3;
    if (/[ilI1.,'`|]/.test(character)) return width + 4;
    if (/[MW@#%&]/.test(character)) return width + 10;
    if (character.charCodeAt(0) > 255) return width + 12;
    return width + 7;
  }, 0);
}

export function measureTextWidth(text: string, font: string) {
  const context = getTextMeasurementContext();
  if (!context) return estimateTextWidth(text);

  context.font = font;
  return context.measureText(text).width;
}
